import React, { ReactElement, useEffect } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useMsal } from '@azure/msal-react';
import { useAuth } from '../../context/AuthContext';
import { HighlightUserIdentifier } from '../HighlightUserIdentifier';

interface PrivateRouteProps {
    children?: ReactElement
}

function PrivateRoute(props: PrivateRouteProps) {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
        return <div>Loading...</div>;
    }

    return isAuthenticated ? (
        <>
            <HighlightUserIdentifier />
            <Outlet />
        </>
    ) : <Navigate to="/login" />;
}

export default PrivateRoute